"use client";
import React from "react";
import SmartImage from "@/components/SmartImage";

const ProductImageFullscreen = ({
    imageUrl,
    className,
    priority,
    setSelectedImage,
    imageAlt,
}: {
    imageUrl: string;
    className?: string;
    priority?: boolean;
    setSelectedImage?: (image: string | null) => void;
    imageAlt?: string;
}) => {
    const openModal = (imgUrl: string) => {
        if (setSelectedImage) {
            setSelectedImage(imgUrl);
        }
    };
    const image = imageUrl.substring(0, imageUrl.lastIndexOf("."));
    
    return (
        <SmartImage
            src={imageUrl}
            alt={imageAlt || "Product image"}
            width={480}
            height={480}
            className={className}
            loading={priority ? "eager" : "lazy"}
            onClick={() => openModal(image)}
        />
    );
};

export default ProductImageFullscreen;
